export const PieChartStyles = {
    PieChartContainer : { 
                    display:"flex",
                    flexDirection:'column', 
                    alignItems:'center', 
                    justifyContent:'center', 
                    width:'100%',
                    height:'100%',
                    borderRadius: 2, 
                    padding: 3, 
                    border:'1px solid rgba(0, 0, 0, 0.12)' 
                }
}